/* eslint-disable array-callback-return */
import React, { useState, useEffect } from "react";
import { Form, Row } from "react-bootstrap";
import "./BusinesssetupPage.css";
import banner_default from "../../../assets/background_banners.webp";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import upload_img from "../../../assets/upload_img.png";
import close_cross from "../../../assets/close_cross.svg";
import store_default from "../../../assets/store_default.png";
import UploadfilesPage from "../../tusimageupload/components/UploadfilesPage";
import { fetchStoredetail } from "../../dashboard/redux/actions";
import { useTranslation } from "react-i18next";
import { fetchLogindata } from "../../login/redux/actions";
import { fetchHeaderContent } from "../../seoroute/redux/actions";
import { LazyLoadImage } from "react-lazy-load-image-component";
import DriversetupPage from "./DriversetupPage";
import {
  formatPhoneNumber,
  formatPhoneNumberturkish,
} from "../../comman/components/TimeSence";
import CropbannerPage from "./CropbannerPage";
import { getRequestcall } from "../../comman/util/getRequest";
import { CREATE_STORE, SEND_NOTIFICATION, SERVICES, STORE_DETAIL } from "../../constants/apiurl";
import { postRequestcall } from "../../comman/util/postRequest";
import ButtonPage from "../../comman/button/ButtonPage";
import StoreProfile from "../../dashboard/components/StoreProfile";
import { FormLabel, FormControl } from "../../comman/formgroup/FormgroupPage";
import AutocompletePlace from "./../../comman/components/AutocompletePlace";
import { clearStoredetail } from "../../dashboard/redux/actions";
import MultiselectPage from "../../comman/customselect/MultiselectPage";
import LoaderPage from "../../loader/components/LoaderPage";


function BusinesssetupPage(props) {

  const [formInput, setFormInput] = useState({
    lat: "",
    lng: "",
    address: "",
    city: "",
    country: "",
    zip_code: "",
    street: "",
    description: "",
    email: "",
    contact: "",
    title: "",
    website_url: "",
    images: "",
    banner_image: "",
    country_code: "+90",
  });
  const { t } = useTranslation();
  const [errors, setErrors] = useState({
    address: "",
    city: "",
    country: "",
    zip_code: "",
    description: "",
    title: "",
    website_url: "",
    category: "",
    storelogo: "",
    businesstype: "",
    street: ""
  });

  const [businesstype, setBusinesstype] = useState("goods");
  const [selectiontype, setselectiontype] = useState([]);
  const [selectservice, setselectservice] = useState([]);
  const [imageName, setImagename] = useState([]);
  const [bannerImageArray, setBannerImageArray] = useState([]);
  let getstoreid = window.location.pathname.split("/").pop();
  let url = window.location.pathname.split("/");
  const [currentUrl] = useState(url[1]);
  const navigate = useNavigate();
  const [showDriver, setShowdrvier] = useState(false);
  const [bannerImage, setBannerimage] = useState();
  const [showcrop, setShowcrop] = useState(false);
  const [showList, setShowList] = useState(false);
  const [loader, setLoader] = useState(false);
  // const nameRegex = /^[A-Za-z ığüşöçİĞÜŞÖÇ]+$/;

  useEffect(() => {
    (async () => getCategories())();
    // eslint-disable-next-line
  }, [props?.language]);

  const getServicesData = async () => {
    let getserviceurl = SERVICES + `?lang=${props.language.toLowerCase()}`;
    let responce = await getRequestcall(getserviceurl, "");
    if (responce?.status === 200) {
      let getservices = await responce.json();
      return getservices;
    }
  };

  const getCategorylist = async () => {
    let responce = await getServicesData();
    let category = {};
    let updated_selection_type = [];
    responce?.data?.forEach((item) => {
      category = {
        value: item.id,
        label: item.title,
        type: item.type,
      };
      updated_selection_type.push(category);
    });
    return updated_selection_type;
  }

  const getCategories = async () => {
    props?.fetchHeaderContent(t("pages.sidenav.setup"), "", "");
    if (props?.logindata?.vendor_type !== "driver") { // No driver call the store detail
      let updated_selection_type = await getCategorylist();
      getStoreDetail(updated_selection_type);
    } else {
      // At the time of driver the type is vendor so driver setup form will display 
      // when driver delete the type is user 
       showDriverForm();
    }
  };

  const showDriverForm = async () => {
    if(props?.type === "vendor") {
      setShowdrvier(true);
      setBusinesstype("driver");
      setFormInput({
        ...formInput,
        email: props?.logindata?.email,
        contact: props?.logindata?.mobile,
        country_code: props?.logindata?.country_code,
      });
    } else {
      let updated_selection_type = await getCategorylist();
      userDetail(updated_selection_type);
    }
  }

  const getStoreDetail = async (categories) => {
    if (props?.type !== "user") {
      let geturl = STORE_DETAIL + `/${getstoreid}/no`;
      let getRes = await getRequestcall(geturl, props?.access_token);
      if (getRes?.status === 200) {
        let storeData = await getRes.json();
        getstoreEditdata(storeData.data, categories);
      } else if (getRes.status === 400) {
        let getError = await getRes.json();
        if (getError?.errors) {
          if (getstoreid !== "") {  // if store id is present then and store delete from backend
            props?.clearStoredetail([]);
            window.history.replaceState(null, "", "/vendor/");
            toast.error(getError?.errors);
          }
        }
        let getList = categories.filter((item) => item?.type === "goods");
        setselectiontype(getList);
        setFormInput({
          ...formInput,
          email: props?.logindata?.email,
          contact: props?.logindata?.mobile,
          country_code: props?.logindata?.country_code,
        });
      } else {
        userDetail(categories); // After store delete when storeDetail get 404 then show the user detail
      }
    } else {
      userDetail(categories);
    }
  };

  const userDetail = (categories) => {
    let getList = categories.filter((item) => item?.type === "goods");
    setselectiontype(getList);
    setFormInput({
      ...formInput,
      email: props?.logindata?.email,
      contact: props?.logindata?.mobile,
      country_code: props?.logindata?.country_code,
    });
  };

  const getstoreEditdata = (storeDetail, categories) => {
    setBusinesstype(storeDetail?.type);
    setFormInput({
      title: storeDetail?.title,
      description: storeDetail?.description,
      website_url: storeDetail?.website_url,
      banner_image: storeDetail?.banner_image,
      email: storeDetail?.email,
      contact: storeDetail?.contact,
      lat: storeDetail?.lat,
      lng: storeDetail?.lng,
      address: storeDetail?.address,
      city: storeDetail?.city,
      country: storeDetail?.country,
      zip_code:
        typeof storeDetail?.zip_code === "undefined"
          ? ""
          : storeDetail?.zip_code,
      street: storeDetail?.address,
      country_code: storeDetail?.country_code,
    });
    if (currentUrl === "vendor") {
      getServiceandimage(storeDetail, categories);
    }
  };

  const getServiceandimage = async (storeDetail, categories) => {
    let getImagename = [];
    let imageObject = {};
    if (storeDetail?.images !== null) {
      if (storeDetail?.images.length > 0) {
        storeDetail?.images.forEach((item) => {
          let getFilename = item.split("/").pop();
          imageObject = {
            preview_url: item,
            fileName: getFilename,
          };
          getImagename.push(imageObject);
        });
        setImagename(getImagename);
      }
    }
    let getImagenameBanner = [];
    let imageObjectBanner = {};
    if (storeDetail?.banner_image !== null) {
      if (storeDetail?.banner_image.length > 0) {
        storeDetail?.banner_image.forEach((item) => {
          let bannerFilename = item.split("/").pop();
          imageObjectBanner = {
            preview_url: item,
            fileName: bannerFilename,
          };
          getImagenameBanner.push(imageObjectBanner);
        });
        setBannerImageArray(getImagenameBanner);
      }
    }
    let serviceArray = [];
    let categoryObject = {};
    let updatedCategorylist = [];
    serviceArray = storeDetail?.service_id?.split(",");
    /// If vendor sign up without category then check if it is null or not
    if (serviceArray?.length > 0) {
      serviceArray?.forEach((getitem) => {
        let getServices = categories?.filter((item, index) => item.value === getitem);
        categoryObject = {
          value: getServices[0]?.value,
          label: getServices[0]?.label,
          type: getServices[0]?.type
        };
        updatedCategorylist.push(categoryObject);
      });
      if (updatedCategorylist.length > 0) {
        // Update the list 
        if (storeDetail?.type === "goods") {
          let getGoods = categories?.filter((item) => item?.type === "goods");
          let difference = getGoods.filter(ar => !updatedCategorylist.find(rm => (rm.value === ar.value)));
          setselectiontype(difference)
        } else {
          let getService = categories?.filter((item) => item?.type === "service");
          let difference = getService.filter(ar => !updatedCategorylist.find(rm => (rm.value === ar.value)))
          setselectiontype(difference)
        }
        setselectservice(updatedCategorylist);
      } else {
        setselectservice([]);
      }
    } else {
      // If vendor sign up without category then check if it is null or not set the store name and image
      let getList = categories.filter((item) => item?.type === "goods");
      setselectiontype(getList);
      let object = {
        store_name: storeDetail?.title,
        store_image: null,
        store_address: storeDetail?.address,
        store_id: storeDetail?.id,
      };
      props.fetchStoredetail(object);
      setselectservice([]);
    }
  };

  const validation = () => {
    let value = true;
    // if (!nameRegex.test(formInput.title)) {
    //   errors.title = "pages.signup.fullname_validation";
    //   value = false;
    // }
    if(!formInput.title.trim()) {
      errors.title = "pages.setupstore.busi_name_warn";
      value = false;
    }
    if (formInput.title === "") {
      value = false;
      errors.title = "pages.setupstore.busi_name_warn";
    }
    if (formInput.address === "") {
      value = false;
      errors.address = "pages.setupstore.address_warn";
    }
    if (formInput.city === "") {
      value = false;
      errors.city = "pages.setupstore.city_warn";
    }
    if (formInput.country === "") {
      errors.country = "pages.setupstore.country_place";
      value = false;
    }
    if (formInput.zip_code === "") {
      value = false;
      errors.zip_code = "pages.setupstore.pincode_warn";
    }
    if (formInput.street === "") {
      value = false;
      errors.street = "pages.setupstore.street_warn";
    }
    if (selectservice.length === 0) {
      value = false;
      errors.category = "pages.setupstore.business_category_warn";
    }
    if (imageName.length === 0) {
      value = false;
      errors.storelogo = "pages.setupstore.upload_warn";
    }
    if (businesstype === "") {
      value = false;
      errors.businesstype = "pages.setupstore.busi_type_warn";
    }
    setErrors({
      ...errors,
      title: errors.title,
      address: errors.address,
      country: errors.country,
      city: errors.city,
      zip_code: errors.zip_code,
      street: errors.street,
      category: errors.category,
      storelogo: errors.storelogo,
      businesstype: errors.businesstype,
      description: errors.description,
    });
    return value;
  };

  const InputChange = (e) => {
    setFormInput({
      ...formInput,
      [e.target.name]: e.target.value,
    });
    setErrors({
      ...errors,
      [e.target.name]: "",
    });
  };

  const selectServicechange = (e, selectedItem, index) => {
    e.preventDefault();
    let updatedlist = [...selectservice]
    updatedlist.push(selectedItem)
    setselectservice(updatedlist);
    // Remove from category list after select
    let getList = selectiontype.filter((item) => item.value !== selectedItem.value);
    setselectiontype(getList);
    setErrors({
      ...errors,
      category: "",
    });
  };

  const closeCurrentimage = (id) => {
    const getImagename = imageName.filter((item, index) => index !== id);
    setImagename(getImagename);
  };

  const submitStoredetail = async (e) => {
    e.preventDefault();
    if (validation()) {
      setLoader(true);
      let service_id = "";
      let images = "";
      let Banner_image = "";
      let updatearray = [];
      if (selectservice.length > 0) {
        selectservice.forEach((item) => {
          updatearray.push(item.value);
        });
        service_id = updatearray.join(",");
      }
      let getImagename = [];
      if (imageName.length > 0) {
        imageName.forEach((item) => {
          getImagename.push(item?.fileName);
        });
        images = getImagename.join(",");
      }
      let getBannerImagename = [];
      if (bannerImageArray.length > 0) {
        bannerImageArray.forEach((item) => {
          getBannerImagename.push(item?.fileName);
        });
        Banner_image = getBannerImagename.join(",");
      }
      // below action parameter used for default vat and offer
      let storeData = {
        address: formInput.address,
        city: formInput.city,
        country: formInput.country,
        zip_code: formInput.zip_code,
        description: formInput.description,
        email: formInput.email,
        contact: formInput.contact,
        title: formInput.title,
        website_url: formInput.website_url,
        lat: formInput.lat,
        lng: formInput.lng,
        banner_image: Banner_image,
        images: images,
        profile_image: "",
        home_delivery: "yes",
        service_id: service_id,
        id: props.type === "user" || props?.logindata?.vendor_type === "driver" ? "" : getstoreid,
        lang: props.language.toLowerCase(),
        type: businesstype,
        action: props.type === "user" || getstoreid === "" ? "yes" : "no",
        country_code: formInput.country_code,
      };
      let getStoreres = await postRequestcall(CREATE_STORE  + `?lang=${props.language.toLowerCase()}`, props?.access_token, storeData);
      if (getStoreres?.status === 200) {
         let storeadd = await getStoreres.json();
        
        if (props?.type === "user" || props?.logindata?.vendor_type === "") {
           props.logindata.type = "vendor"; // If type is user then convert type into vendor when user create store or when user will work as a driver
          props.logindata.vendor_type = businesstype;
          props.fetchLogindata(props.logindata);
        }
        setLoader(false);
        var timestamp = new Date().getTime();
        toast.success(storeadd?.msg);
        navigate("/vendor/dashboard", { state: { obj: timestamp } });
        if (props?.type === "user") {
          let geturl = SEND_NOTIFICATION + `?type=${"store"}&id=${storeadd?.data?.id}`
          await postRequestcall(geturl, props?.access_token, "");
        }
      } else if (getStoreres?.status === 400) {
        let getError = await getStoreres?.json();
        props?.clearStoredetail([]);
        window.history.replaceState(null, "", "/vendor/");
        toast.error(getError?.errors);
        setLoader(false);
      } else { 
        setLoader(false);
      }
    }
  };

  const SetLocation = async ({ place, address, Lat, lng, ZipCode }) => {
    let city = "";
    let country = "";
    place.address_components.forEach((item) => {
      switch (item.types[0]) {
        case "locality":
          city = item.long_name;
          break;
        case "country":
          country = item.long_name;
          break;
        default:
          break;
      }
    });
    setFormInput({
      ...formInput,
      lat: Lat,
      lng: lng,
      address: address,
      city: city,
      country: country,
      zip_code: typeof ZipCode === "undefined" ? "" : ZipCode,
      street: address,
    });
  }

  const locationValueChange = (value) => {
    setFormInput({
      ...formInput,
      address: value,
    });
    setErrors({
      ...errors,
      country: "",
      city: "",
      zip_code: "",
      address: "",
    });
  };

  const typeChange = async (e) => {
    setErrors({
      ...errors,
      category: "",
    });
    switch (e.target.id) {
      case "goods":
        setShowdrvier(false);
        setBusinesstype("goods");
        break;
      case "service":
        setShowdrvier(false);
        setBusinesstype("service");
        break;
      default:
        setShowdrvier(true);
        setBusinesstype("driver");
        break;
    }
    let updated_selection_type = await getCategorylist();
    if (e.target.id === "goods" || e.target.id === "service") {
      let getUpdatedlist = updated_selection_type?.filter((item) => item.type === e.target.id);
      setselectiontype(getUpdatedlist);
    }
    setselectservice([]);
  };

  const uploadFile = () => {
    setErrors({
      ...errors,
      storelogo: "",
    });
  };

  const handleFilechange = async (e) => {
    try {
      if (
        e.target.files[0].type === "image/png" ||
        e.target.files[0].type === "image/jpg" ||
        e.target.files[0].type === "image/jpeg" ||
        e.target.files[0].type === "image/jfif" ||
        e.target.files[0].type === "image/svg" ||
        e.target.files[0].type === "image/apng" ||
        e.target.files[0].type === "image/avif" ||
        e.target.files[0].type === "image/gif" ||
        e.target.files[0].type === "image/webp"
      ) {
        let fileurl = URL.createObjectURL(e?.target?.files[0]);
        setBannerimage(fileurl);
        setShowcrop(true);
        e.target.value = "";
      } else {
        toast.error(t("pages.Invalid image type"));
      }
    } catch (error) { }
  };

  const storeFiles = (getImage, type) => {
    let imagevalue = [...imageName];
    imagevalue.push(getImage);
    setImagename(imagevalue);
  };
  const StoreData = {
    ...props?.storeDetail,
    banner_image: bannerImageArray?.length > 0 ? bannerImageArray[0]?.preview_url : banner_default,
    store_name: formInput?.title, store_address: formInput.address, ...formInput,
    store_image: imageName[0]?.preview_url === null || imageName.length === 0 ? store_default : imageName[0]?.preview_url,
    bannerImageArray: bannerImageArray?.length > 0 ? bannerImageArray[0]?.preview_url : banner_default
  }

  const removeCategory = (e, getItem) => {
    e.stopPropagation();
    e.preventDefault();
    let updatedlist = [...selectservice];
    let updatedCategory = [...selectiontype];
    updatedlist = updatedlist.filter((item) => item.value !== getItem.value);
    setselectservice(updatedlist);
    // After remove add into the list 
    // But list is in sequence format 
    if (businesstype === "service") {
      let getService = props?.serviceslist?.map((item) => {
        return {
          value: item.id,
          label: item.title,
          type: item.type,
        }
      })
      updatedCategory = getService.filter(val => { return !updatedlist.find((val2) => { return val?.value === val2?.value }) });
      setselectiontype(updatedCategory);
    } else {
      let getGoods = props?.categories.filter((item) => item?.type === "goods");
      getGoods = getGoods?.map((item) => {
        return {
          value: item.id,
          label: item.title,
          type: item.type,
        }
      })
      updatedCategory = getGoods.filter(val => { return !updatedlist.find((val2) => { return val?.value === val2?.value }) });
      setselectiontype(updatedCategory);
    }
    setShowList(false);
  }

  const clearSelected = async (e, getItem) => {
    e.stopPropagation();
    e.preventDefault();
    setselectservice([]);
    // After remove add into the list
    let updated_selection_type = await getCategorylist();
    let getUpdatedlist = updated_selection_type?.filter((item) => item.type === businesstype);
    setselectiontype(getUpdatedlist);
    setShowList(false);
  }

  if(loader) {
    return <LoaderPage
    className={"col-xl-9 user-dashboard"}
    />
  }

  return (
    <div className={getstoreid === "business-setup" ? "col-12" : "col-xl-9"} >
    <div className={`busines-setup mb-5 pb-1`}>
      {(props?.logindata?.vendor_type !== "driver" || props?.type === "user") && (
          <StoreProfile
            storedetail={StoreData}
            innerClass={
              currentUrl !== "vendor"
                ? "stores-div col-xl-12 py-4 px-4"
                : "stores-div edit-store col-xl-12 mb-5"
            }
            className={"storeprofilediv comman"}
            type={"StoreProfile"}
            editBanner={true}
            onChange={handleFilechange}
          />
       )}
      <div className={"container px-0"}>
        <div className={"col-12"}>
          <div className="main-content form-content">
            <div className="card">
              <div className="card-body">
                <h5 className="header-title">
                  {props.type === "user"
                    ? t("pages.Add your business")
                    : t("pages.setupstore.title")}
                </h5>
                <p>{t("pages.setupstore.subtitle")}</p>
                <Form>
                  <Row>
                    <div className="col-12 mb-3">
                      {/* for only vendor show goods and service */}
                      {(props?.logindata?.vendor_type !== "driver" || props?.type === "user") && (
                      <div className="mb-3 pt-2 col-sm-12 col-md-12 col-lg-12 col-xl-12 ">
                        <FormLabel label={t("pages.setupstore.Select Business type")} />
                        <div className="selection_type">
                              <Form.Check
                                label={t("pages.setupstore.Goods")}
                                className="radio-btn"
                                id="goods"
                                type="radio"
                                checked={businesstype === "goods" ? true : false}
                                onChange={typeChange}
                              />
                              <Form.Check
                                id="service"
                                type="radio"
                                label={t("pages.setupstore.Service")}
                                className="radio-btn ms-4"
                                checked={businesstype === "service" ? true : false}
                                onChange={typeChange}
                              />
                           {/* for user and first time registration show driver selection */}
                          {(props?.logindata?.vendor_type === "" || props?.type === "user") && (
                            <Form.Check
                              label={t("pages.Driver")}
                              className="radio-btn ms-4"
                              id="driver"
                              type="radio"
                              checked={businesstype === "driver" ? true : false}
                              onChange={typeChange}
                            />
                          )}
                        </div>
                      </div>)}
                      {!showDriver && (
                        <div className="mb-3 col-sm-12 col-md-12 col-lg-12 col-xl-12 upload-profiles">
                          <FormLabel label={t("pages.setupstore.upload")} />
                          <div
                            className="multi-upload-img store-img-uppy"
                            onClick={() => uploadFile()}
                          >
                            <UploadfilesPage storeFiles={storeFiles} type={"setup-store"} />
                            <div
                              className="text-danger"
                              style={{ whiteSpace: "nowrap" }}
                            >
                              {imageName.length === 0
                                ? t(errors.storelogo)
                                : ""}
                            </div>
                          </div>
                          {imageName?.map((item, index) => (
                            <div
                              className="multi-upload-img"
                              style={{ marginBottom: "20px" }}
                            >
                              <img
                                src={close_cross}
                                onClick={() => closeCurrentimage(index)}
                                className="close-icon"
                                color={"#ff0300"}
                                alt="close"
                              />
                              <LazyLoadImage
                                src={item?.preview_url}
                                onError={(e) => {
                                  e.target.src = upload_img;
                                }}
                                className="product-img"
                                alt="product image"
                              />
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                    {showDriver ? (
                      <DriversetupPage setLoader={setLoader}/>
                    ) : (
                      <>
                        <div className="mb-3 mt-4 pt-2 col-sm-12 col-md-12 col-lg-12 col-xl-12 ">
                          <FormLabel label={t("pages.setupstore.busi_name")} />
                          <FormControl placeholder={t("pages.setupstore.busi_name_place")} value={formInput.title} name={"title"} onChange={InputChange} error={t(errors.title)} />
                        </div>
                        <div className="mb-3 col-sm-6 col-md-6 col-lg-6 col-xl-6 ">
                          <FormLabel label={t("pages.setupstore.address")} />
                          <AutocompletePlace
                            setAddress={locationValueChange}
                            address={formInput?.address}
                            placaddress={t("pages.setupstore.address_place")}
                            SetLocation={SetLocation}
                            className={"bussinesssetup-location"}
                          />
                          <span className="text-danger">{t(errors.address)}</span>
                        </div>
                        <div className="mb-3 col-sm-6 col-md-6 col-lg-6 col-xl-6 ">
                          <FormLabel label={t("pages.setupstore.country")} />
                          <FormControl placeholder={t("pages.setupstore.country_place")} type={"text"} value={formInput.country} name={"country"} onChange={InputChange} error={t(errors.country)} />
                        </div>
                        <div className="mb-3 col-sm-6 col-md-6 col-lg-6 col-xl-6 ">
                          <FormLabel label={t("pages.setupstore.city")} />
                          <FormControl placeholder={t("pages.setupstore.city_place")} type={"text"} value={formInput.city} name={"city"} onChange={InputChange} error={t(errors.city)} />
                        </div>
                        <div className="mb-3 col-sm-6 col-md-6 col-lg-6 col-xl-6 ">
                          <FormLabel label={t("pages.setupstore.pincode")} />
                          <FormControl placeholder={t("pages.setupstore.pincode_place")} type={"text"} value={formInput.zip_code} name={"zip_code"} onChange={InputChange} error={t(errors.zip_code)} />
                        </div>
                        <div className="mb-3 col-sm-6 col-md-6 col-lg-6 col-xl-6 ">
                          <FormLabel label={t("pages.setupstore.street")} />
                          <FormControl placeholder={t("pages.setupstore.street_place")} type={"text"} value={formInput.street} name={"street"} onChange={InputChange} error={t(errors.street)} />
                        </div>
                        <div className="mb-3 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                          <FormLabel label={t("pages.setupstore.business_category")} />
                          <MultiselectPage
                            remove={removeCategory}
                            list={selectiontype}
                            setShowList={setShowList}
                            showList={showList}
                            sublist={selectservice}
                            placeholder={t("pages.add_product.category_place")}
                            clearSelected={clearSelected}
                            groupItemClick={selectServicechange}
                          />
                          <span className="warning text-danger">
                            {t(errors.category)}
                          </span>
                        </div>
                        <div className="mb-3 col-sm-12 col-md-12 col-lg-12 col-xl-12 ">
                          <div
                            className={"col-sm-6 col-md-6 col-lg-6 col-xl-6 "}
                          >
                            <FormLabel require={false} label={t("pages.setupstore.description")} />
                            <FormControl rows={3} style={{ height: "auto" }} as="textarea" placeholder={t("pages.setupstore.description_place")} type={"textarea"} value={formInput.description} name={"description"} onChange={InputChange} error={t(errors.description)} />
                          </div>
                        </div>
                        <div className="mb-3 col-sm-6 col-md-6 col-lg-6 col-xl-6 ">
                          <FormLabel label={t("pages.setupstore.email_address")} />
                          <FormControl placeholder={t(
                            "pages.setupstore.email_address_place"
                          )} type={"text"} value={formInput.email} name={"email"} onChange={InputChange} disabled={true} />
                        </div>
                        <div className="mb-3 col-sm-6 col-md-6 col-lg-6 col-xl-6 ">
                          <FormLabel label={t("pages.setupstore.phone")} />
                          <FormControl placeholder={t("pages.setupstore.phone_place")} type={"text"} value={formInput.country_code === "+91"
                            ? formInput.country_code +
                            " " +
                            formatPhoneNumber(formInput.contact)
                            : formInput.country_code +
                            " " +
                            formatPhoneNumberturkish(formInput.contact)} name={"contact"} disabled={true} />
                        </div>
                        <div className="mb-3 col-sm-6 col-md-6 col-lg-6 col-xl-6 ">
                          <FormLabel require={false} label={t("pages.setupstore.busi_url")} />
                          <FormControl placeholder={"e.g https://www/appristine.com"} error={t(errors.website_url)} type={"text"} value={formInput.website_url} name={"website_url"} onChange={InputChange} />
                        </div>
                        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-end">
                          <ButtonPage
                            Text={
                              t("pages.setupstore.submit_detail")
                            }
                            onClick={(e) => submitStoredetail(e)}
                            className={`button-submit m-2 hover-btn`}
                          />
                        </div>
                      </>
                    )}
                  </Row>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <CropbannerPage
        showcrop={showcrop}
        bannerImage={bannerImage}
        setBannerImageArray={setBannerImageArray}
        setShowcrop={setShowcrop}
      ></CropbannerPage>
    </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  access_token: state?.login?.access_token,
  currentLocation: state?.home?.currentLocation,
  categories: state?.home?.categories,
  storeDetail: state?.dashboard?.storeDetail,
  language: state?.languageState?.language,
  logindata: state?.login?.logindata,
  type: state?.login?.type,
  
  email: state?.login?.email,
  mobile: state?.login?.mobile,
  serviceslist: state?.home?.serviceslist,
});

export default connect(mapStateToProps, {
  fetchStoredetail,
  fetchLogindata,
  fetchHeaderContent,
  clearStoredetail
})(BusinesssetupPage);
